import React, {Component, useContext, useEffect, useState} from 'react';
import ReactDOM from 'react-dom';
import { Layout, MinMaxLayout, SixtyFourtyLayout } from '../../../layouts';
import Welcome from '../../../layouts/welcome';
import Row from '../../../components/row';
import { ButtonCancel, ButtonReturn, ButtonSave, ButtonView } from '../../../components/buttons';
import Container from '../../../layouts/containers/container';
import List from '../../../components/list';

import TabBar from '../components/tab-bar';
import Grid from '../../../components/grid';
import InputsText from '../../../components/inputs/inputs-text';
import companiesApi from '../../../lib/companies/companies-api';

import ContainerTable from '../.././../layouts/containers/container-table';
import ContainerIndex from '../../../layouts/containers/container-index';
import { stringToFriendlyDatetime } from '../../../lib/helpers/datetime-helpers';

import { toast } from 'react-toastify';
import Item from '../../../components/item';

import { FaMoneyBill, FaReceipt } from 'react-icons/fa';

import PopupsViewBillingProfile from '../popups/popups-view-billing-profile';
import PopupContext from '../../../context/context-popup';
import PopupsViewReceipt from '../popups/popups-view-receipt';
import RenderThisIf from '../../../components/renderIf';
import EmptyState from '../../../components/states/empty';
import Divider from '../../../components/divider/divider';

const relations = {
    'App\\Models\\MeetingRoomBooking': {
        name: 'Meeting Room Booking',
        url: '/mydmc/bookings'
    },
    'App\\Models\\CoWorkingBooking': {
        name: 'Co-Working Booking',
        url: '/mydmc/co-working/bookings'
    },
    'App\\Models\\EventBooking': {
        name: 'Event Booking',
        url: '/mydmc/events'
    },
    'App\\Models\\MeetingRoomBookingVersion': {
        name: 'Meeting Room Booking Version',
        url: '/mydmc/bookings',
    }
}

const Receipts = () => {
    const { setPopup } = useContext(PopupContext);

    const [ receipts, setReceipts ] = useState([]);
    const [ meta, setMeta ] = useState({});
    const [ page, setPage ] = useState(1);

    const fetch = () => {
        setReceipts(null);
        
        companiesApi.getReceipts(window.user?.company_id, {
            per_page: 6,
            page
        }).then(({ data, meta }) => {
            setReceipts(data);
            setMeta(meta);
        })
    }

    const viewReceipt = (details, relation) => {
        setPopup(<PopupsViewReceipt details={details} relation={relation}/>);
    }

    useEffect(() => {
        fetch();
    }, [])

    useEffect(() => {
        fetch();
    }, [ page ])

    return (
        <List gap="40px">
            <Container style={{
                height: receipts?.length > 0 ? '' : '608.86px'
            }}>
                <Container.Header>
                    <Container.Text fontSize="20px" color="black" fontWeight='500'>Receipts</Container.Text>
                </Container.Header>

                <RenderThisIf
                    renderIf={receipts?.length === 0 || receipts === null}
                    render={
                        <EmptyState 
                            loading={receipts === null} 
                            title="Receipts" 
                            description="Nothing to see here" 
                            titleColor="black"
                            descriptionColor="black"
                            style={{ height: '100%' }}
                        />
                    }
                >
                    <Container.Content style={{
                        height: '100%'
                    }}>
                        <List gap="20px">
                            { receipts?.map((receipt, index) => {
                                const billed_to = receipt?.billing_profile;
                                const billed_type = billed_to?.billable_type;

                                let name = '';
                                let company = billed_to?.company_name;

                                const relation = relations?.[receipt?.related_to];

                                let url = '';

                                if (relation) {
                                    url = relation.url;

                                    if (relation.name === 'Event Booking') {
                                        url = `/events/${receipt?.meta?.event?.id}/bookings/${quote?.related_id}`
                                    }
                                }

                                if (billed_type === "App\\Models\\Company" || billed_type === "App\\Models\\Contact") {
                                    name = `${billed_to?.first_name} ${billed_to?.last_name}`;
                                }

                                if (billed_type === "App\\Models\\User") {
                                    name = `${billed_to?.name}`;
                                }

                                return <Item
                                    key={index}
                                    icon={<FaReceipt/>}
                                    details={
                                        <List gap="5px">
                                            <Container.Text fontSize="14px">{ name }</Container.Text>
                                            <Container.Text fontSize="12px" color="#1577EA">{ relation?.name } - { stringToFriendlyDatetime(receipt?.created_at) } - Total: £{ receipt?.total || 0 }</Container.Text>
                                        </List>
                                    }
                                    action={<ButtonView mobile onClick={() => viewReceipt(receipt, relation)}/>}
                                />
                            })}

                        <ContainerIndex.Pagination
                            color="black"
                            currentPage={page}
                            maxPages={meta?.last_page}
                            onNext={() => setPage(page + 1)}
                            onPrevious={() => setPage(page - 1)}
                        />
                        </List>
                    </Container.Content>
                </RenderThisIf>
            </Container>
        </List>
    )
}

const BillingProfiles = () => {
    const { setPopup } = useContext(PopupContext);

    const [ profiles, setProfiles ] = useState([]);
    const [ meta, setMeta ] = useState({});
    const [ page, setPage ] = useState(1);

    const fetch = () => {
        setProfiles(null);

        companiesApi.getBillingProfiles(window.user?.company_id, {
            per_page: 6,
            page
        }).then(({ data, meta }) => {
            setProfiles(data);
            setMeta(meta);
        })
    }

    const viewBillingProfile = (profile) => {
        setPopup(<PopupsViewBillingProfile profile={profile}/>);
    }

    useEffect(() => {
        fetch();
    }, [])

    useEffect(() => {
        fetch();
    }, [ page ])

    return (
        <List gap="40px">
            <Container style={{
                height: profiles?.length > 0 ? '' : '608.86px'
            }}>
                <Container.Header>
                    <Container.Text fontSize="20px" color="black" fontWeight='500'>Previous Billing Profiles</Container.Text>
                </Container.Header>

                <RenderThisIf
                        renderIf={profiles?.length === 0 || profiles === null}
                        render={
                            <EmptyState 
                                loading={profiles === null} 
                                title="Billing Profiles" 
                                description="Nothing to see here" 
                                titleColor="black"
                                descriptionColor="black"
                                style={{ height: '100%' }}
                            />
                        }
                    >
                    <Container.Content style={{
                        height: '100%'
                    }}>
                        <List gap="20px">
                            { profiles?.map((profile, index) => {
                                const address = `${profile?.address_one ?? ''} ${profile?.address_two ?? ''} ${profile?.postcode ?? ''} ${profile?.county ?? ''} ${profile?.country ?? ''}`;

                                return <Item
                                    key={index}
                                    icon={<FaMoneyBill/>}
                                    details={
                                        <List gap="5px">
                                            <Container.Text fontSize="14px">{ address.trim().length > 0 ? address : `Profile ${index + 1}` }</Container.Text>
                                            <Container.Text fontSize="12px" color="#1577EA">{ stringToFriendlyDatetime(profile?.created_at) }</Container.Text>
                                        </List>
                                    }
                                    action={<ButtonView mobile onClick={() => viewBillingProfile(profile)}/>}
                                />
                            })}

                            <ContainerIndex.Pagination
                                color="black"
                                currentPage={page}
                                maxPages={meta?.last_page}
                                onNext={() => setPage(page + 1)}
                                onPrevious={() => setPage(page - 1)}
                            />
                        </List>
                    </Container.Content>
                </RenderThisIf>
            </Container>
        </List>
    )
}

class Billing extends Component {
    constructor(props) {
        super(props);

        this.state = {
            errors: {},
            details: null,
            loading: true,
        }
    }

    componentDidMount() {
        this.fetch();
    }

    fetch() {
        companiesApi.getCompany(window.user?.company_id).then(({ data }) => {
            this.setState({ 
                loading: false,
                details: data?.billing_profile,
            })
        })
    }

    onChange(e) {
        const { name, value } = e.target;
        const details = { ...this.state.details }

        details[name] = value;

        this.setState({ details })
    }

    getFilteredDetails() {
        return Object.fromEntries(Object.entries(this.state.details).filter(([key, value]) => value !== null));
    }

    update() {
        companiesApi.updateBillingProfile(window.user?.company_id, this.state.details !== null ? this.getFilteredDetails() : {}, (errors) => {
            toast.error("Could not update billing profile", {
                position: toast.POSITION.BOTTOM_CENTER
            });

            this.setState({ errors })
        }).then(() => {
            toast.success("Successfully updated", {
                position: toast.POSITION.BOTTOM_CENTER
            });

            this.setState({ errors: {} }, () => {
                this.fetch();
            })
        })
    }

    render() {
        return (
            <Layout 
                theme="light"
                loading={this.state.loading}
                topLeft={
                    <Welcome 
                        title={<Container.Text fontSize="18px" color="#FF6933">Manage</Container.Text>}
                        subtitle="My Billing"
                    />
                }
                topRight={
                    <Row gap="20px">
                        <ButtonSave onClick={this.update.bind(this)}>Save</ButtonSave>
                        <ButtonReturn>Cancel</ButtonReturn>
                    </Row>
                }
            >
                <List gap="40px">
                    <TabBar active={3}/>

                    <SixtyFourtyLayout
                        main={
                            <List gap="40px" divider={<Divider color="#D7E2F0"/>}>
                                <Container>
                                    <Container.Header>
                                        <Container.Text fontSize="20px" color="black" fontWeight='500'>Billing Profile</Container.Text>
                                    </Container.Header>

                                    <Container.Content>
                                        <Grid columns={2} gap="20px">
                                            <InputsText
                                                label="Title"
                                                name="title"
                                                value={this.state.details?.title}
                                                onChange={this.onChange.bind(this)}
                                                errors={this.state.errors?.title}
                                                
                                            />

                                            <InputsText
                                                label="First Name"
                                                name="first_name"
                                                value={this.state.details?.first_name}
                                                onChange={this.onChange.bind(this)}
                                                errors={this.state.errors?.first_name}
                                                
                                            />

                                            <InputsText
                                                label="Last Name"
                                                name="last_name"
                                                value={this.state.details?.last_name}
                                                onChange={this.onChange.bind(this)}
                                                errors={this.state.errors?.last_name}
                                                
                                            />

                                            <InputsText
                                                label="Email Address"
                                                name="email_address"
                                                value={this.state.details?.email_address}
                                                onChange={this.onChange.bind(this)}
                                                errors={this.state.errors?.email_address}
                                                
                                            />

                                            <InputsText
                                                label="Address One"
                                                name="address_one"
                                                value={this.state.details?.address_one}
                                                onChange={this.onChange.bind(this)}
                                                errors={this.state.errors?.address_one}
                                                
                                            />

                                            <InputsText
                                                label="Address Two"
                                                name="address_two"
                                                value={this.state.details?.address_two}
                                                onChange={this.onChange.bind(this)}
                                                errors={this.state.errors?.address_two}
                                                
                                            />

                                            <InputsText
                                                label="City"
                                                name="city"
                                                value={this.state.details?.city}
                                                onChange={this.onChange.bind(this)}
                                                errors={this.state.errors?.city}
                                                
                                            />

                                            <InputsText
                                                label="Company Name"
                                                name="company_name"
                                                value={this.state.details?.company_name}
                                                onChange={this.onChange.bind(this)}
                                                errors={this.state.errors?.company_name}
                                                
                                            />

                                            <InputsText
                                                label="Country"
                                                name="country"
                                                value={this.state.details?.country}
                                                onChange={this.onChange.bind(this)}
                                                errors={this.state.errors?.country}
                                                
                                            />

                                            <InputsText
                                                label="County"
                                                name="county"
                                                value={this.state.details?.county}
                                                onChange={this.onChange.bind(this)}
                                                errors={this.state.errors?.county}
                                                
                                            />

                                            <InputsText
                                                label="Postcode"
                                                name="postcode"
                                                value={this.state.details?.postcode}
                                                onChange={this.onChange.bind(this)}
                                                errors={this.state.errors?.postcode}
                                                
                                            />

                                            <InputsText
                                                label="Telephone Number"
                                                name="tel_no"
                                                value={this.state.details?.tel_no}
                                                onChange={this.onChange.bind(this)}
                                                errors={this.state.errors?.tel_no}
                                                
                                            />

                                            <InputsText
                                                label="Mobile Number"
                                                name="mob_no"
                                                value={this.state.details?.mob_no}
                                                onChange={this.onChange.bind(this)}
                                                errors={this.state.errors?.mob_no}
                                                
                                            />

                                            <InputsText
                                                label="PO Number"
                                                name="po_number"
                                                value={this.state.details?.po_number}
                                                onChange={this.onChange.bind(this)}
                                                errors={this.state.errors?.po_number}
                                                
                                            />
                                        </Grid>
                                    </Container.Content>
                                </Container>

                                <Receipts/>
                            </List>
                        }
                        sectionOne={
                            {
                                name: '',
                                component: <BillingProfiles/>
                            }
                        }
                    />
                </List>
            </Layout>  
        )
    }
}

const el = document.getElementById('account-billing');

if (el) {
    ReactDOM.render(
        <Billing/>  
    , el);
}
